<!-- src/app/login/login.component.html -->
<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-5">
      <div class="card shadow-sm">
        <div class="card-body p-4">
          
          <!-- Login View -->
          <ng-container *ngIf="currentView === 'login'">
            <h2 class="card-title text-center mb-4">Iniciar Sesión</h2>
            <div *ngIf="authSuccessMessage" class="alert alert-success" role="alert">{{ authSuccessMessage }}</div>
            <form [formGroup]="loginForm" (ngSubmit)="onLogin()" novalidate>
              <div class="mb-3">
                <label for="loginEmail" class="form-label">Correo Electrónico</label>
                <input type="email" class="form-control" id="loginEmail" formControlName="email" placeholder="Ingrese su correo">
              </div>
              <div class="mb-3">
                <label for="loginPassword" class="form-label">Contraseña</label>
                <input type="password" class="form-control" id="loginPassword" formControlName="password" placeholder="Ingrese su contraseña">
              </div>
              <div *ngIf="authError" class="alert alert-danger" role="alert">{{ authError }}</div>
              <div class="d-grid gap-2 mt-4">
                <button type="submit" class="btn btn-primary btn-lg" [disabled]="loginForm.invalid || isLoading">
                  <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ isLoading ? 'Ingresando...' : 'Iniciar Sesión' }}
                </button>
              </div>
              <div class="text-center mt-3">
                <a href="javascript:void(0);" (click)="changeView('forgot_password')">¿Olvidaste tu contraseña?</a>
              </div>
              <div class="text-center mt-2">
                <span>¿No tienes cuenta? </span><a href="javascript:void(0);" (click)="changeView('signup')">Crear cuenta</a>
              </div>
            </form>
          </ng-container>

          <!-- Signup View -->
          <ng-container *ngIf="currentView === 'signup'">
            <h2 class="card-title text-center mb-4">Crear Cuenta</h2>
            <form [formGroup]="signupForm" (ngSubmit)="onSignup()" novalidate>
              <div class="mb-3">
                <label for="signupEmail" class="form-label">Correo Electrónico</label>
                <input type="email" class="form-control" id="signupEmail" formControlName="email" placeholder="Ingrese su correo">
              </div>
              <div class="mb-3">
                <label for="signupPassword" class="form-label">Contraseña</label>
                <input type="password" class="form-control" id="signupPassword" formControlName="password" placeholder="Mínimo 6 caracteres">
              </div>
              <div class="mb-3">
                <label for="signupConfirmPassword" class="form-label">Confirmar Contraseña</label>
                <input type="password" class="form-control" id="signupConfirmPassword" formControlName="confirmPassword" placeholder="Repita su contraseña">
                <div *ngIf="signupForm.errors?.['passwordMismatch'] && signupForm.get('confirmPassword')?.touched" class="text-danger small mt-1">
                  Las contraseñas no coinciden.
                </div>
              </div>
              <div *ngIf="authError" class="alert alert-danger" role="alert">{{ authError }}</div>
              <div class="d-grid gap-2 mt-4">
                <button type="submit" class="btn btn-primary btn-lg" [disabled]="signupForm.invalid || isLoading">
                  <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ isLoading ? 'Creando...' : 'Crear Cuenta' }}
                </button>
              </div>
              <div class="text-center mt-3">
                <span>¿Ya tienes cuenta? </span><a href="javascript:void(0);" (click)="changeView('login')">Iniciar sesión</a>
              </div>
            </form>
          </ng-container>

          <!-- Forgot Password View -->
          <ng-container *ngIf="currentView === 'forgot_password'">
            <h2 class="card-title text-center mb-4">Restablecer Contraseña</h2>
            <p class="text-muted text-center">Ingrese su correo electrónico para recibir un enlace de restablecimiento.</p>
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPassword()" novalidate>
              <div class="mb-3">
                <label for="forgotEmail" class="form-label">Correo Electrónico</label>
                <input type="email" class="form-control" id="forgotEmail" formControlName="email" placeholder="Ingrese su correo">
              </div>
              <div *ngIf="authError" class="alert alert-danger" role="alert">{{ authError }}</div>
              <div *ngIf="authSuccessMessage" class="alert alert-success" role="alert">{{ authSuccessMessage }}</div>
              <div class="d-grid gap-2 mt-4">
                <button type="submit" class="btn btn-primary btn-lg" [disabled]="forgotPasswordForm.invalid || isLoading">
                  <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ isLoading ? 'Enviando...' : 'Enviar Enlace' }}
                </button>
              </div>
              <div class="text-center mt-3">
                <a href="javascript:void(0);" (click)="changeView('login')">Volver a iniciar sesión</a>
              </div>
            </form>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>
